import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { $countryProvincesStore, $countriesStore, $transferCurrenciesStore } from '@lib/store';
import { cn, PaletteUtils } from '@shared/utils';
import { type AccountResponse, TransferRecipientTypeEnum } from '@shared/api';
import { OtherAccountIndividualTab } from './otherAccountIndividualTab';
import { OtherAccountBusinessTab } from './otherAccountBusinessTab';
import { Tabs } from '@shared/widgets';

interface OtherAccountTabProps {
  account: AccountResponse | null;
}

export const OtherAccountTab = (props: OtherAccountTabProps) => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type') as TransferRecipientTypeEnum | null;

  const [tab, setTab] = useState<TransferRecipientTypeEnum>(type || TransferRecipientTypeEnum.Individual);

  const { t } = useTranslation();

  useEffect(() => {
    Promise.allSettled([
      $countriesStore.events.getCountries(),
      $countryProvincesStore.events.getCountryProvinces(),
      $transferCurrenciesStore.events.getTransferCurrencies(),
    ]);
  }, []);

  const TABS = useMemo(
    () => [
      { value: TransferRecipientTypeEnum.Individual, label: t('recipientType.individual') },
      { value: TransferRecipientTypeEnum.Business, label: t('recipientType.business') },
    ],
    [t],
  );
  return (
    <div className={cn('mt-6', PaletteUtils.isVcfcPalette && 'mt-0')}>
      <div className='bg-white p-6 dark:bg-soft-black'>
        <Tabs options={TABS} value={tab} onChange={setTab} />
      </div>
      {tab == TransferRecipientTypeEnum.Individual && <OtherAccountIndividualTab account={props.account} />}
      {tab === TransferRecipientTypeEnum.Business && <OtherAccountBusinessTab account={props.account} />}
    </div>
  );
};
